export default __webpack_public_path__ + "static/media/Cabin3.e1444608.jpg";